import { put, takeEvery, call, takeLatest } from "redux-saga/effects";
import { userConstants } from "../constants/user.constants";
import { callAPI } from "./commonApiCall";
import apiURLs from "../config/url-config";
import { setUserDetails, removeUserDetails } from "../utils/user";
import { userActions, alertActions } from "../actions";
import { Encryption } from "../utils/Encryption";

//#region User logout/user profile
function* userLogout(action) {
  try {
    //const data = yield call(callAPI, apiURLs.logoutUrl, action.payload);
    yield call(removeUserDetails);
    yield put(userActions.logoutSuccess());
  } catch (error) {}
}

function* getBasicDetails() {
  try {
    const data = yield call(callAPI, apiURLs.getBasicDetails);

    // set data to store on success
    if (data.status === true) {
      data.data = JSON.parse((new Encryption()).decrypt(data.data));
      yield call(setUserDetails, data.data);
      yield put(userActions.getBasicDetailsSuccess(data.data));
    } else {
      //show error message
      yield put(alertActions.error(data.message));
    }
  } catch (error) {
    yield put(
      alertActions.error("Unable to retirieve profile details at the moment.")
    );
  }
}

//#endregion


function* sendVerificationEmail(action) {
  try {
    const data = yield call(
      callAPI,
      apiURLs.userUrl.sendVerificationEmail
    );

    if (data.status === true) {
      yield put(alertActions.success(data.message));
    } else {
      yield put(alertActions.error(data.message));
    }
  } catch (error) {}
}

function* validateVerificationEmail(action) {
  try {
    const data = yield call(callAPI, apiURLs.userUrl.validateVerificationEmailTokenUrl, action.payload);
    
    if (data.status === true) {
      yield put(alertActions.success(data.message));
      yield put(userActions.validateVerificationEmailTokenSuccess(data));
    } else {
      yield put(alertActions.error(data.message));
    }
  } catch (error) {}
}

function* changePassword(action) {
  try {
    const data = yield call(callAPI, apiURLs.changePassword, action.payload);
    
    if (data.status === true) {
      yield put(alertActions.success(data.message));
      yield put(userActions.changePasswordSuccess(data));
    } else {
      yield put(alertActions.error(data.message));
    }
  } catch (error) {}
}

export function* userSaga() {
  yield takeLatest(userConstants.GET_BASIC_DETAIL_REQUEST, getBasicDetails);
  
  yield takeLatest(userConstants.SEND_VERIFICATION_EMAIL_REQUEST, sendVerificationEmail);
  yield takeEvery(userConstants.VALIDATE_VERIFICATION_EMAIL_TOKEN_REQUEST, validateVerificationEmail);

  yield takeEvery(userConstants.CHANGE_PASSWORD, changePassword);
  yield takeEvery(userConstants.LOGOUT, userLogout);
}
